export const categories = [
  {
    slug: "fantasy",
    name: "奇幻专题",
    shortName: "奇幻",
    tagline: "异世界 · 魔法 · 热血冒险",
    description:
      "韩漫大全奇幻专题聚焦异世界、魔法学院、史诗冒险与超能力设定，从高燃战斗到宏大世界观一应俱全，适合喜欢脑洞与热血故事的读者。",
    icon: "ri-sword-fill",
    accent: "primary",
  },
  {
    slug: "campus",
    name: "校园专题",
    shortName: "校园",
    tagline: "青春 · 恋爱 · 日常成长",
    description:
      "韩漫大全校园专题收录青春恋爱、社团日常、青春成长类佳作，甜度与温度并存，细腻描摹学生时代的心动与蜕变。",
    icon: "ri-book-2-fill",
    accent: "accent",
  },
  {
    slug: "ancient",
    name: "古风专题",
    shortName: "古风",
    tagline: "宫廷 · 玄幻 · 古装爱恋",
    description:
      "韩漫大全古风专题汇集古代宫廷权谋、玄幻仙侠与古装浪漫，华美服饰与东方意境交织，演绎跨越时空的动人故事。",
    icon: "ri-landscape-fill",
    accent: "secondary",
  },
];

export const allCategories = [
  { slug: "all", name: "全部作品", shortName: "全部", icon: "ri-archive-2-fill", accent: "secondary" },
  ...categories,
];